import styled from "styled-components";
import GridCardComponent from "./generic/GridCardComponent";
import { useEffect, useState } from "react";
import { ReactComponent as ZapFast } from "../../../assets/icons/zap-fast.svg";
import { ReactComponent as Turtle1 } from "../../../assets/icons/Turtle_1_.svg";
import { ReactComponent as Eye } from "../../../assets/icons/eye2.svg";
import { ReactComponent as ChevronLeft } from "../../../assets/icons/chevron-left1.svg";
import { ReactComponent as ChevronRight } from "../../../assets/icons/chevron-right1.svg";
import { Tooltip } from "antd";
import BOTagOverProductCard from "../../pages/products/BOTagOverProductCard";
import LazyThumbnail from "../LazyThumbnail";

// #region  SCOPED CSS
const StyledPage = styled.div`
    .Colors {
        color: var(--text-icons-gray-100, #d1d1d1);

        /* Subtitle 3 */
        font-family: Roboto;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .Frame264-2 {
        flex: 1 0 0;
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .RectangleBoxes {
        width: 16px;
        height: 16px;
        border-radius: 2px;
        cursor: pointer;
        border: 1px solid #fff;
    }

    .RectangleBoxes.selected {
        border: 2px solid #fff;
    }

    .Frame383 {
        display: flex;
        width: 16px;
        height: 16px;
        padding: 10px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        border-radius: 2px;
        background: var(--backgrounds-lines-n-500, #141922);
    }

    .Counter5 {
        color: var(--text-icons-gray-100, #d1d1d1);

        /* Label/XS-Lowercase */
        font-family: Roboto;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    //SIZES
    .Frame385 {
        flex: 1 0 0;
        justify-content: flex-end;
        align-items: center;
        gap: 4px;
        display: flex;
    }

    .size {
        color: var(--text-icons-blue-500, #00aeef);

        /* Label/XS-Lowercase */
        font-family: Roboto;
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .SizeBoxes {
        border-radius: 2px;
        background: var(--backgrounds-lines-n-500, #141922);
        cursor: pointer;
        display: flex;
        height: 16px;
        padding: 4px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        white-space: nowrap;
    }

    .Counter3 {
        color: var(--text-icons-gray-100, #d1d1d1);

        /* Label/XS-Lowercase */
        font-family: Roboto;
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    //BOTAG Button
    .Frame263 {
        display: flex;
        padding: 8px;
        align-items: flex-start;
        gap: 10px;

        position: absolute;
        right: 9px;
        bottom: 11px;

        border-radius: 500px;
        background: var(--backgrounds-lines-n-600, #10141b);

        /* drop-shadow-100 */
        box-shadow: 0px 0px 10px 0px #111620;
    }

    .Tag03 {
        width: 16px;
        height: 16px;
    }

    //ImageThumbnails
    .frame-313318-2 {
        background: rgba(20, 25, 34, 0.5);
        border-radius: 0px;
        padding: 8px 32px 8px 32px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 55px;
        position: absolute;
        bottom: 0px;
    }
    .ImageBoxes {
        border-radius: 4px;
        flex-shrink: 0;
        width: 25px;
        height: 39px;
        position: relative;
        object-fit: cover;
    }

    .ImageThumb {
        border-radius: 4px;
        flex-shrink: 0;
        width: 25px;
        height: 39px;
        position: relative;
        object-fit: cover;
    }
    .frame-383 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 25px;
        height: 39px;
        position: relative;
    }
    .Counter5 {
        color: #ffffff;
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 7px;
        font-weight: 400;
        position: relative;
    }

    .ImageArrows {
        width: 16px;
        height: 17px;
        cursor: pointer;
    }

    .NextPreviousArrowsContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .NextPreviousArrowsContainer .arrow-left {
        position: relative;
        cursor: pointer;
        left: 0;
        color: #ffffff;
        opacity: 1;
        filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8));
        transition: all 0.3s ease-in-out;
    }

    .NextPreviousArrowsContainer .arrow-left:hover {
        opacity: 1;
        transform: scale(1.2);
    }

    .NextPreviousArrowsContainer .arrow-right {
        position: relative;
        cursor: pointer;
        right: 0;
        color: #ffffff;
        opacity: 1;
        filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8));
        transition: all 0.3s ease-in-out;
    }

    .NextPreviousArrowsContainer .arrow-right:hover {
        opacity: 1;
        transform: scale(1.2);
    }

    .invisible-custom {
        opacity: 0 !important;
        cursor: default !important;
    }
`;

const StyledShelfSpeedView = styled.div`
    &.ShelfSpeedView {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        width: 100%;
        position: relative;
    }

    .sunset {
        flex-shrink: 0;
        width: 11px;
        height: 11px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        top: -1px;
    }

    ._1-9-dimming {
        //color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
`;
// #endregion

/**
 * Renders a grid card component for displaying brand information.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.className - The CSS class name for the component.
 * @param {string} props.title - The title of the brand.
 * @param {string} props.id - The ID of the brand.
 * @param {boolean} props.hasBorders - Indicates if the card has borders.
 * @param {string} [props.titlePrefix="BRAND"] - The prefix for the title.
 * @param {string} [props.idPrefix="BOTAG ID"] - The prefix for the ID.
 * @param {boolean} props.isCardEnabled - Indicates if the card is enabled.
 * @param {boolean} props.isCardSuspended - Indicates if the card is suspended.
 * @param {string} props.image - The image URL for the brand.
 * @param {Object[]} props.details - The details to display in the card.
 * @param {string} props.details[].key - The key of the detail.
 * @param {string} props.details[].value - The value of the detail.
 * @param {Object} props.edit - The edit button configuration.
 * @param {Object} props.suspend - The suspend button configuration.
 * @param {Object} props.delete - The delete button configuration.
 * @param {Object} props.statusLog - The status log button configuration.
 * @returns {JSX.Element} The rendered ProductGridCard component.
 */
export default function ProductGridCard(props) {
    // #region VARS
    const status = props?.data?.status ?? "--";

    const reference = props?.data?.reference || "--";
    const colors = props?.colors?.map(it => it?.hexacode);
    const uniqueColors = [...new Set(colors?.map(c => c?.trim().toLowerCase()))];
    const sizes = props?.data?.sizes;
    const shelfSpeed = props?.data?.shelfSpeed || "--";
    const season = props?.data?.season || "--";

    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const [mainImage, setMainImage] = useState(null);
    const [mainImageSlider, setMainImageSlider] = useState({
        index: 0,
        images: []
    });
    // eslint-disable-next-line no-unused-vars
    const [thumbnailImages, setThumbnailImages] = useState([]);
    const [showBOTag, setShowBOTag] = useState(false);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!selectedColor || !selectedSize) {
            if (!colors?.length || !sizes?.length) return;

            setSelectedColor(colors?.[0] || null);
            setSelectedSize(sizes?.[0] || null);

            setMainImage(props?.colors?.[0]?.images?.[0]);
            //setThumbnailImages(props?.colors?.[0]?.images);
            setMainImageSlider({
                index: 0,
                images: props?.colors?.[0]?.images
            });
        }
    }, [colors, sizes]);
    // #endregion

    // #region METHODS
    const handleColorClick = color => {
        setSelectedColor(color);

        const colorObj = props?.colors?.find(it => it?.hexacode?.toLowerCase() === color?.toLowerCase());
        //setThumbnailImages(colorObj?.images);
        setMainImage(colorObj?.images?.[0]);
        setSelectedImage(null);
        setMainImageSlider({
            index: 0,
            images: colorObj?.images
        });
    };

    const handleSizeClick = size => {
        setSelectedSize(size);
    };

    const tagOnclick = () => {
        setShowBOTag(true);
    };

    const onClose = () => {
        setShowBOTag(false);
    };

    const handleImageClick = image => {
        setSelectedImage(image);
    };
    // #endregion

    // #region RENDER
    return (
        <StyledPage className={`${props?.className || ""}`}>
            <GridCardComponent
                {...props}
                primaryButton={{
                    title: props?.primaryButton?.title || "DETAILS",
                    onClick: props?.primaryButton?.onClick
                }}
                secondaryButton={{
                    title: props?.secondaryButton?.title || "METRICS",
                    onClick: props?.secondaryButton?.onClick
                }}
                thirdButton={{
                    title: props?.thirdButton?.title || "ORDER",
                    onClick: props?.thirdButton?.onClick
                }}
                id={props?.id}
                hasBorders={props?.hasBorders}
                titlePrefix={"LABEL BRAND"}
                title={props?.labelBrandName}
                secondaryTitlePrefix={"STYLE NAME"}
                secondaryTitle={props?.title}
                idPrefix={props?.idPrefix}
                isCardEnabled={props?.isCardEnabled}
                isCardSuspended={props?.isCardSuspended}
                image={selectedImage || mainImage}
                imageHasPadding={false}
                imageHeight="465px"
                imageFit="cover"
                showSelections={true}
                highlighted={props?.highlighted}
                highlightColor={props?.highlightColor}
                highlightCustomText={props?.highlightCustomText}
                details={[
                    { key: "Shelf Speed:", value: <ShelfSpeedView shelfSpeed={shelfSpeed} /> },
                    { key: "Item nr.:", value: reference ?? "--" },
                    { key: "Collection/Season:", value: season ?? "--" },
                    {
                        key: "Colors:",
                        value: (
                            <ColorsUI
                                uniqueColors={uniqueColors}
                                selectedColor={selectedColor}
                                handleColorClick={handleColorClick}
                                colorNames={props?.colorNames}
                                isCardEnabled={props?.isCardEnabled}
                            />
                        ),
                        hideTooltip: true
                    },
                    {
                        key: "Sizes:",
                        value: (
                            <SizesUI
                                sizes={sizes}
                                selectedSize={selectedSize}
                                handleSizeClick={handleSizeClick}
                                isCardEnabled={props?.isCardEnabled}
                            />
                        )
                    },
                    {
                        key: "Stores:",
                        value: `${props?.totalStoresWithStock || "0"} ${
                            props?.lastStockCheck ? `( ${props?.lastStockCheck} )` : ""
                        }`
                    },
                    {
                        key: "Items sold:",
                        value: props?.data?.totalItemsSold ?? "--"
                    },
                    {
                        key: "My stock:",
                        value: `${props?.totalStockInStores || "0"} ${
                            props?.lastStockCheck ? `( ${props?.lastStockCheck} )` : ""
                        }`
                    },
                    {
                        key: "Supplier stock:",
                        value: `${props?.supplierStock || "0"} ${
                            props?.lastSupplierStockCheck ? `( ${props?.lastSupplierStockCheck} )` : ""
                        }`
                    }
                ]}
                //edit={props?.edit}
                suspend={props?.suspend}
                //delete={props?.delete}
                edit={{ hidden: true }}
                delete={{ hidden: true }}
                statusLog={props?.statusLog}
                showStatusLog={props?.showStatusLog}
                noOfRows={9}
                status={status}
                imageOverlayComponent={
                    <>
                        <NextPreviousArrows
                            mainImageSlider={mainImageSlider}
                            setMainImageSlider={setMainImageSlider}
                            setMainImage={setMainImage}
                        />

                        <BOtagButton
                            tagOnclick={tagOnclick}
                            boTagData={props?.boTagData}
                            style={{
                                bottom: thumbnailImages?.length > 0 ? "66px" : "11px"
                            }}
                        />

                        <BOTagOverProductCard
                            visible={showBOTag}
                            onClose={onClose}
                            data={props?.boTagData}
                            selectedColor={selectedColor}
                            selectedSize={selectedSize}
                        />

                        {thumbnailImages?.length > 0 && (
                            <ImageThumbnails
                                images={thumbnailImages}
                                //selectedImage={selectedImage}
                                handleImageClick={handleImageClick}
                            />
                        )}
                    </>
                }
            />
        </StyledPage>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const getHexColor = color => {
    if (color === "0" || color === 0) return "#000000";
    if (!color) return "transparent";
    const colorStr = "#" + color.replace("#", "");
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colorStr)) return "transparent";

    return colorStr;
};

const ShelfSpeedView = ({ shelfSpeed }) => {
    //shelfSpeed = "Fast";

    const hasShelfSpeed = ["Fast", "Watchlist", "Watch List", "Slow"].includes(shelfSpeed);
    if (!hasShelfSpeed)
        return <div style={{ height: "14px", color: "var(--text-icons-blue-500)", fontSize: "12px" }}>--</div>;

    const shelfSpeedColor =
        shelfSpeed === "Fast"
            ? "#00FF00"
            : shelfSpeed === "Watchlist" || shelfSpeed === "Watch List"
              ? "#FFA500"
              : "#FF0000";

    const shelfSpeedText =
        shelfSpeed === "Watchlist" || shelfSpeed === "Watch List" ? shelfSpeed : `${shelfSpeed} mover`;

    const shelfSpeedTextColor = "#d1d1d1";

    return (
        <StyledShelfSpeedView className="ShelfSpeedView" style={{ height: "14px" }}>
            {shelfSpeed === "Fast" ? (
                <ZapFast alt="acceleration" className="sunset" style={{ color: shelfSpeedColor }} />
            ) : shelfSpeed === "Slow" ? (
                <Turtle1 alt="acceleration" className="sunset" style={{ color: shelfSpeedColor }} />
            ) : (
                <Eye alt="acceleration" className="sunset" style={{ color: shelfSpeedColor }} />
            )}
            <div className="_1-9-dimming" style={{ color: shelfSpeedTextColor }}>
                {shelfSpeedText}
            </div>
        </StyledShelfSpeedView>
    );
};

const ColorsUI = ({ uniqueColors, selectedColor, handleColorClick, colorNames, isCardEnabled }) => {
    return (
        <div className="Frame264-2">
            {uniqueColors?.slice(0, 10)?.map((color, index) => {
                return (
                    <Tooltip
                        placement="top"
                        key={"colors_" + index}
                        title={colorNames?.[index] || ""}
                        color="var(--backgrounds-lines-n-200)"
                        mouseEnterDelay={0.3}
                        overlayClassName="custom-tool-tip">
                        <div
                            className={`RectangleBoxes ${
                                selectedColor?.toLowerCase() === color?.toLowerCase() ? "selected" : ""
                            }`}
                            style={{ background: getHexColor(color) }}
                            key={index}
                            onClick={() => handleColorClick(color)}
                        />
                    </Tooltip>
                );
            }) ?? <div className={`${isCardEnabled ? "text-gray-100" : "text-gray-300"}`}>--</div>}

            {uniqueColors?.length > 10 && (
                <div className="Frame383">
                    <div className="Counter5">+{uniqueColors?.length - 10}</div>
                </div>
            )}
        </div>
    );
};

const SizesUI = ({ sizes, selectedSize, handleSizeClick, isCardEnabled }) => {
    return (
        <div className="Frame385">
            {sizes?.slice(0, 5).map((size, index) => {
                return (
                    <div
                        className={`SizeBoxes ${selectedSize === size ? "selected" : ""}`}
                        key={index}
                        onClick={() => handleSizeClick(size)}>
                        <div className="size">{size}</div>
                    </div>
                );
            }) ?? <div className={`${isCardEnabled ? "text-gray-100" : "text-gray-300"}`}>--</div>}
            {sizes?.length > 5 && (
                <div className="SizeBoxes">
                    <div className="Counter3">+{sizes?.length - 5}</div>
                </div>
            )}
        </div>
    );
};

const BOtagButton = ({ tagOnclick, boTagData, style }) => {
    return (
        <Tooltip placement="top" title="Show BOTag" color="#212121" overlayClassName="custom-tool-tip">
            <div
                className={`Frame263 ${tagOnclick && boTagData ? "cursor-pointer" : ""}`}
                style={style}
                onClick={() => (boTagData ? tagOnclick() : undefined)}>
                <svg
                    className={`Tag03 ${tagOnclick && boTagData ? "" : "hover-not-allowed"}`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none">
                    <path
                        d="M14 7.3335L8.93726 2.27075C8.59135 1.92485 8.4184 1.7519 8.21657 1.62822C8.03762 1.51856 7.84254 1.43775 7.63846 1.38876C7.40829 1.3335 7.16369 1.3335 6.67452 1.3335L4 1.3335M2 5.80016L2 7.11651C2 7.44263 2 7.60569 2.03684 7.75914C2.0695 7.89519 2.12337 8.02525 2.19648 8.14454C2.27894 8.2791 2.39424 8.3944 2.62484 8.625L7.82484 13.825C8.35286 14.353 8.61687 14.617 8.92131 14.716C9.1891 14.803 9.47757 14.803 9.74536 14.716C10.0498 14.617 10.3138 14.353 10.8418 13.825L12.4915 12.1753C13.0195 11.6473 13.2835 11.3833 13.3825 11.0789C13.4695 10.8111 13.4695 10.5226 13.3825 10.2548C13.2835 9.95037 13.0195 9.68636 12.4915 9.15834L7.62484 4.29167C7.39424 4.06107 7.27894 3.94577 7.14438 3.86331C7.02508 3.7902 6.89502 3.73633 6.75898 3.70367C6.60553 3.66683 6.44247 3.66683 6.11634 3.66683H4.13333C3.3866 3.66683 3.01323 3.66683 2.72801 3.81215C2.47713 3.93999 2.27316 4.14396 2.14532 4.39484C2 4.68006 2 5.05343 2 5.80016Z"
                        stroke={tagOnclick && boTagData ? "var(--text-icons-gray-100)" : "var(--text-icons-gray-300)"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        </Tooltip>
    );
};

const ImageThumbnails = ({ images, selectedImage, handleImageClick }) => {
    // #region VARS
    const maxImages = 6;
    const imageList = images || [];
    const hasMoreImages = imageList.length > maxImages;
    const [startIndex, setStartIndex] = useState(0);

    useEffect(() => {
        if (!hasMoreImages) {
            setStartIndex(0);
        } else if (startIndex >= imageList.length) {
            setStartIndex(0);
        }
    }, [imageList, hasMoreImages, startIndex, maxImages]);
    // #endregion

    // #region METHODS
    const handleArrowClick = direction => {
        if (!hasMoreImages) return;

        setStartIndex(prev => {
            if (direction === "left") {
                const nextIndex = prev - maxImages;
                return nextIndex < 0 ? 0 : nextIndex;
            } else {
                // right
                const nextIndex = prev + maxImages;
                // If next page starts after the end of array, stay on current
                if (nextIndex >= imageList.length) return prev;
                return nextIndex;
            }
        });
    };
    // #endregion

    const visibleImages = hasMoreImages ? imageList.slice(startIndex, startIndex + maxImages) : imageList;

    // Determine visibility of arrows
    const canScrollLeft = startIndex > 0;
    const canScrollRight = startIndex + maxImages < imageList.length;

    return (
        <div className="frame-313318-2">
            {hasMoreImages && canScrollLeft && (
                <div
                    className="ImageArrows arrow-left"
                    style={{ position: "absolute", left: "5px", color: "#D1D1D1" }}
                    onClick={() => handleArrowClick("left")}>
                    <ChevronLeft />
                </div>
            )}

            {hasMoreImages && canScrollRight && (
                <div
                    className="ImageArrows arrow-right"
                    style={{ position: "absolute", right: "5px", color: "#D1D1D1" }}
                    onClick={() => handleArrowClick("right")}>
                    <ChevronRight />
                </div>
            )}

            {visibleImages?.map((image, index) => {
                const originalIndex = hasMoreImages ? startIndex + index : index;
                // We use the image URL as part of the key if possible, or just the index relative to the view.
                // Using just 'index' (0-3) works for slots.
                return (
                    <LazyThumbnail
                        key={index}
                        src={image}
                        alt={`Product thumbnail ${originalIndex + 1}`}
                        width={25}
                        height={39}
                        className={`ImageBoxes ${selectedImage === image ? "selected" : ""}`}
                        onClick={() => {
                            if (handleImageClick) handleImageClick(image);
                        }}
                        style={{
                            border: selectedImage === image ? "2px solid #00aeef" : "none"
                        }}
                    />
                );
            })}

            {/* no longer used since we are using arrows
            hasMoreImages && (
                <div className="frame-383">
                    <div className="Counter5">+{images?.length - maxImages}</div>
                </div>
            )*/}
        </div>
    );
};

const NextPreviousArrows = ({ mainImageSlider, setMainImageSlider, setMainImage }) => {
    const handleArrowClick = direction => {
        const newImageIndex = direction === "left" ? mainImageSlider.index - 1 : mainImageSlider.index + 1;

        if (newImageIndex >= 0 && newImageIndex < mainImageSlider.images.length) {
            setMainImageSlider({
                index: newImageIndex,
                images: mainImageSlider.images
            });

            setMainImage(mainImageSlider.images[newImageIndex]);
        }
    };

    return (
        <div className="NextPreviousArrowsContainer">
            <div
                className={`ImageArrows2 arrow-left ${mainImageSlider?.index > 0 ? "" : "invisible-custom"}`}
                onClick={() => handleArrowClick("left")}>
                <ChevronLeft height={30} width={30} />
            </div>

            <div
                className={`ImageArrows2 arrow-right ${mainImageSlider?.index < mainImageSlider?.images?.length - 1 ? "" : "invisible-custom"}`}
                onClick={() => handleArrowClick("right")}>
                <ChevronRight height={30} width={30} />
            </div>
        </div>
    );
};
// #endregion
